module.exports = __webpack_public_path__ + "static/media/check.d6392bdf.svg";